import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Space } from 'antd';
import { getFullName } from '@/utils';
import { useGetChildPhotosQuery, useGetChildQuery } from '@/services/child-api';
import { PlusSvg, SignOutAltSvg } from '@/assets/icons';
import Page from '@/components/page';
import PageTitle from '@/components/page-title';
import Button from '@/components/button';
import Photo from './photo';
import UploadModal from './upload-modal';

const PhotoManager = () => {
  const { childId } = useParams();
  const navigate = useNavigate();

  const { data } = useGetChildQuery({ childId });
  const breadcrumb = [
    { path: '/child', label: 'Children' },
    data && {
      path: `/child/${childId}`,
      label: `[${data.childCode}] ${getFullName(data.name)}`,
    },
    'Manage Photos',
  ];

  const { data: photos, isLoading: loadingPhotos, refetch } = useGetChildPhotosQuery({ childId });
  const [isOpenUploadModal, openUploadModal] = useState(false);

  return (
    <>
      <style>
        {`
          .custom-space .ant-space-item {
            align-self: flex-start;
          }
        `}
      </style>
      <Page breadcrumb={breadcrumb} loading={loadingPhotos} size="xl">
        <PageTitle label="Manage Photos" />
        <Button
          type="link"
          icon={<PlusSvg />}
          style={{ width: '100%', height: 35, backgroundColor: 'white' }}
          onClick={() => openUploadModal(true)}
        >
          Click Here to upload a new photo
        </Button>
        <Space wrap size="middle" style={{ justifyContent: 'left', alignItems: 'normal' }}>
          {photos?.map((item) => (
            <Photo key={item.blobId} info={item} refetch={refetch} />
          ))}
        </Space>

        <UploadModal
          childId={childId}
          referral={data?.referral}
          open={isOpenUploadModal}
          refetch={refetch}
          onClose={() => openUploadModal(false)}
        />
        <Button
          type="link"
          icon={<SignOutAltSvg />}
          style={{ width: '10%', height: 35, backgroundColor: 'white', marginTop: '10px' }}
          onClick={() => navigate(-1)}
        >
          Return
        </Button>
      </Page>
    </>
  );
};

export default PhotoManager;
